import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import MuiDialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: 0,
    top: 0,
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, closeIcon, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose && closeIcon ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large">
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "25px 0 0 0",
  },
}));

export default function PopUp(props) {
  const { title, children, openPopUp, setOpenPopUp, onClose, closeIcon } =
    props;
  const classes = useStyles();
  return (
    <Dialog open={openPopUp} onClose={onClose} scroll="paper" closeIcon={closeIcon}>
      {closeIcon && (
        <DialogTitle onClose={onClose}>
          {/* <div>Title goes here</div> */}
        </DialogTitle>
      )}
      <DialogContent classes={{ root: classes.root }}>{children}</DialogContent>
    </Dialog>
  );
}
